import { z } from "zod";
import { LocalizedTextSchema, RoleSchema, TierSchema, idPattern } from "./common.js";
import { AbilityRefSchema } from "./unit.js";

export const ZombieDefSchema = z.object({
  id: idPattern("zmb"),
  name: LocalizedTextSchema,
  roleAnalogue: RoleSchema,
  tier: TierSchema,
  boss: z.boolean(),
  statMult: z.object({ hp: z.number().positive(), atk: z.number().positive(), def: z.number().positive(), speed: z.number().positive() }),
  abilities: z.array(AbilityRefSchema).min(1).max(5),
  variants: z.tuple([z.literal("fresh"), z.literal("decayed"), z.literal("mutated")]),
  description: LocalizedTextSchema,
});
export type ZombieDef = z.infer<typeof ZombieDefSchema>;
